// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CCqt","content":"styles_content__2pJz-"};